module.exports = __webpack_public_path__ + "img/cloud_top@2x.e1398123.png";